import React from 'react'
import { Link } from 'react-router-dom';
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { theme } from 'styled-tools';

function SeoContentHomePage61(props: any) {
    const { app: {
        brandId
    }, theme: { config } } = props;

    let domainURL = 'https://www.fun88ind.com';

    if (brandId === 46) {
        domainURL = 'https://www.fun88.site';
    }
    else if (brandId === 47) {
        domainURL = 'https://www.fun88ind.com';
    }

    const domainName = (brandId === 46 || brandId === 47) ? 'Fun88' : 'Fun88';

    return (
        <>
            <AccordionWrapper>
                <Accordion>
                    <input type="checkbox" id="section1" className="accordion__input" />
                    <label htmlFor="section1" className="accordion__label"><h1>Crypto Gaming and Sports Betting Online</h1></label>
                    <div className="accordion__content">
                        <h2>Crypto Gaming and Sports Betting Online</h2>
                        <p>Crypto gaming and sports betting are the present and future of entertainment. If you want to experience a secure and rewarding online casino and sports betting experience, dive into the largest crypto gambling site, Yolo247. It is a global site, meaning that you can access it from anywhere and experience the joy of crypto casino and sports betting.</p>

                        <h2>Yolo247 - Online Crypto Casino and Sports Betting Platform</h2>
                        <p>Sports betting, casino fun, and crypto are a match made in heaven! But what if you get the best of these 3 under one roof? Yes! That is possible on a safe and trusted crypto sports betting platform, Yolo247. We, the best crypto live casino, crypto gaming, and bitcoin betting platform, provide a delightful and rewarding online casino and sports betting experience.</p>
                        <p>We are the biggest crypto gambling site that hosts a wide range of engaging decentralized online casino games and sports betting options. Set yourself free on the road to glory and join the most fun and safe online crypto betting platform, Yolo247.</p>

                        <h2>Yolo247 - Your Go-To Platform for Online Crypto Gaming</h2>
                        <p>Yolo247, the best crypto sports betting and casino platform, brings to you a wide range of casino games and sports betting options. Our platform is an absolute feast for online casino enthusiasts, as we host several games under the following categories:</p>
                        <ul>
                            <li>Crypto Card Games</li>
                            <li>Crypto Wheel Games</li>
                            <li>Crypto Dice Games</li>
                            <li>Crypto Crash Games</li>
                            <li>Crypto Slot Games</li>
                        </ul>
                        <p>Under each of the above categories, you will find numerous games offered by trusted online casino gaming providers. Apart from all the fun casino games, we also have multiple sports like cricket, football, tennis, and more, where you can do sports betting. Our cryptocurrency sports betting platform is also extremely fast when it comes to deposits and withdrawals.</p>

                        <p><strong>CTA: </strong><Link to="/app-download">Download Now</Link></p>

                        <h2>Why is Yolo247 Your Best Choice for Crypto Gambling?</h2>
                        <p>We stand apart from various USDT betting platforms by offering rewarding, fun, and engaging online crypto casino games and sports betting options. The following are some of the reasons why you should jump on our platform to get started with your crypto sports betting and casino journey:</p>

                        <h2>Effortless and Quick Login</h2>
                        <p>Tired of those multiple steps to get yourself registered on a particular platform? We understand your pain. At Yolo247, it just takes a few minutes and simple steps to get yourself registered and started. Login and get access to multiple crypto casino games and sports betting options.</p>

                        <h2>Diverse Crypto Casino Games and Sports Betting Options</h2>
                        <p>Our blockchain betting platform has got you covered when it comes to entertainment, fun casino games, and sports betting options. You will be spoilt for choices, as you will get multiple slot games, table games, crash games, wheel games, and more. Our decentralized crypto sports betting platform takes the joy of betting on sports like cricket, football, and more, to the next level. Various sports leagues and tournaments are covered on Yolo247, making it the most preferred choice for crypto sports betting.</p>

                        <h2>Generous Rewards and Bonuses</h2>
                        <p>You are special and always deserve more. Keeping your invaluable presence on our platform in mind, we offer exciting rewards and bonuses. These bonuses depend on your different actions and winnings, including a welcome bonus, a refill bonus, a referral bonus, and a cashback bonus.</p>

                        <h2>Top-Notch Security and Safety Vault</h2>
                        <p>You work hard to earn the money, and we work hard to keep it safe with our safety vault. While you enjoy casino games and sports betting on our crypto gambling platform, you also get the assurance that the platform is absolutely secure and built for fast and safe crypto transactions.</p>

                        <h2>24/7 Customer Support</h2>
                        <p>Feeling stuck or have any queries? You have us for 24/7 customer support. Relax, play your favorite crypto casino games, earn big with sports betting, and just contact us when you feel stuck or have any queries. With round-the-clock support, you are just one message, email, or call away from quick solutions to your queries.</p>

                        <h2>Fast Crypto Transactions</h2>
                        <p>While we are the safest online crypto sports betting and casino platform, we are also the fastest. All your crypto transactions, including deposits and withdrawals, are super fast, meaning that you can truly concentrate on things that matter: casino gaming and sports betting.</p>

                        <h2>Dedicated to Going Above and Beyond</h2>
                        <p>Our commitment to you is not just limited to what we offer but what you would get in the future as well. We are constantly looking to better your crypto gaming and sports betting experience, with a focus on technology.</p>

                        <h2>Easy Crypto Deposit Betting Site</h2>

                        <h2>Crypto Games and Sports</h2>
                        <p>We have multiple crypto sports betting options and casino games that players can play, bet, and win huge rewards. Let us explore the different categories of casino games, casino game types, and sports betting options available on our crypto gaming platform.</p>

                        <h2>Crypto Casino Games</h2>
                        <p>There are plenty of engaging crypto casino games on our platform. You can explore different crypto casino games and win massive rewards on Yolo247.</p>

                        <h2>Category of Crypto Casino Games</h2>
                        <p>The following are the various categories of crypto casino games on Yolo247:</p>

                        <h3>Crypto Instant Win Games</h3>
                        <p>Crypto Instant win casino games are those that are highly rewarding, fast-paced, and without a live dealer. These quick games deliver maximum returns while also providing immense entertainment.</p>

                        <h3>Crypto Live Casino</h3>
                        <p>In these crypto games, you have a live dealer who moderates the game and makes it engaging. This category has all the top crypto casino games that offer incredible winnings.</p>

                        <h3>Crypto Slots and Bingo</h3>
                        <p>If you want to enjoy the crypto slots and bingo games, then Yolo247 is the perfect platform. There are different varieties of slots that we offer, making us a preferred platform for slot gaming enthusiasts.</p>

                        <h3>Popular Games</h3>
                        <p>This category consists of games that our players enjoy the most. We add games to this section depending on how many players play that particular game. Find the most popular games and start playing them.</p>

                        <h3>Hot Games</h3>
                        <p>These are the games that have a higher winning potential and are extremely easy to understand. This section also has newly launched games; explore all the games, enjoy, and start winning.</p>

                        <h2>Crypto Casino Game Types</h2>
                        <p>The following are a few of the most popular crypto casino game types that are available on our platform:</p>

                        <h3>Card Games</h3>
                        <p>Enjoy the best crypto card games on Yolo247.</p>
                        <ol>
                            <li>Andar Bahar</li>
                            <li>Teen Patti</li>
                            <li>Baccarat</li>
                            <li>Dragon Tiger</li>
                            <li>Blackjack</li>
                            <li>Poker</li>
                            <li>Hi Lo</li>
                        </ol>

                        <h3>Wheel Games</h3>
                        <p>Experience the thrill of crypto wheel games on Yolo247.</p>
                        <ol>
                            <li>Dream Catcher</li>
                            <li>Lightning Roulette</li>
                            <li>XXXtreme Lightning Roulette</li>
                            <li>Funky Time</li>
                            <li>Crazy Time</li>
                            <li>Standard Roulette</li>
                            <li>Monopoly</li>
                        </ol>

                        <h3>Dice Games</h3>
                        <p>Experience the dice magic with crypto dice games on Yolo247.</p>
                        <ol>
                            <li>Dice</li>
                            <li>Sic Bo</li>
                            <li>Super Sic Bo</li>
                            <li>Lightning Dice</li>
                            <li>Bonus Dice</li>
                            <li>Red Blue Dual</li>
                            <li>Street Dice</li>
                        </ol>

                        <h3>Crash Games</h3>
                        <p>Enjoy the best of crypto casino games with our crash games.</p>
                        <ol>
                            <li>Aviator</li>
                            <li>Aviatrix</li>
                            <li>JetX</li>
                            <li>Rocketon</li>
                            <li>Cash Show</li>
                            <li>JetX3</li>
                            <li>Crash</li>
                        </ol>

                        <h3>Slot Games</h3>
                        <p>Get an engaging online casino experience with our crypto slot games.</p>
                        <ol>
                            <li>Fruit Shop</li>
                            <li>Starburst</li>
                            <li>Rome: The Golden Age</li>
                            <li>Golden 777</li>
                            <li>Gordon Ramsay’s Hell’s Kitchen</li>
                            <li>Blood Suckers</li>
                            <li>Dracula</li>
                        </ol>

                        <h2>Crypto Sports Betting Options</h2>
                        <p>To experience crypto sports betting at its best, you need to get on the most reliable and rewarding online crypto sports betting platform, Yolo247. Numerous sports, competitive odds, a live betting experience with crypto, and the different sports betting categories make Yolo247 the top crypto gambling site.</p>

                        <h2>Competitive Odds</h2>
                        <p>We understand what you need the most when it comes to the best crypto sports betting experience: competitive odds. With our highly competitive odds, we ensure that you get an incredible crypto sports betting experience and the best possible returns.</p>

                        <h2>Live Betting Experience with Crypto Currency</h2>
                        <p>The craze for sports betting is on the rise, and one of the main reasons is live betting with cryptocurrency. While there are many platforms that provide live betting experiences, only we provide it with competitive odds while covering plenty of sports events.</p>

                        <h2>Yolo247 Online Crypto Sports Betting Categories</h2>
                        <p>The following are the 4 crypto online sports betting categories on Yolo247:</p>
                        <ol>
                            <li>Betting Exchange</li>
                            <li>Crypto Sportsbook</li>
                            <li>Premium Sportsbook</li>
                            <li>Virtual Sports Betting</li>
                        </ol>
                        <p>All the above sports crypto betting options are available across different sports like cricket, football, tennis, and more.</p>
                        <p><strong>CTA:</strong> Place Crypto Sports Bets Now</p>

                        <h2>Best Crypto Sports to Bet On Yolo247</h2>
                        <p>When it comes to offering the best sports for crypto betting, we are always on top. We offer sports for betting that can give you massive returns. The following are the best crypto sports that we offer:</p>
                        <ol>
                            <li>Cricket</li>
                            <li>Basketball</li>
                            <li>Football</li>
                            <li>Volleyball</li>
                            <li>Kabaddi</li>
                            <li>Badminton</li>
                            <li>Tennis</li>
                        </ol>

                        <h2>Best Tournaments to Bet On Yolo247</h2>
                        <p>Online sports betting is quite popular, and one of the main reasons is the various top-class tournaments that capture the attention of sports and betting enthusiasts. The following are some of the elite sports tournaments that are available to bet on our platform:</p>
                        <ol>
                            <li>IPL (Indian Premier League)</li>
                            <li>CPL (Caribbean Premier League)</li>
                            <li>BBL (Big Bash League)</li>
                            <li>T20 World Cup (T20 WC)</li>
                            <li>PSL (Pakistan Super League)</li>
                            <li>EPL (English Premier League)</li>
                            <li>World Cup (ODI)</li>
                            <li>FIFA World Cup</li>
                        </ol>
                        <p>Apart from all the exciting sporting events mentioned above, there are 4 grand slams every year, various football leagues around the world, the Olympics, and many more.</p>

                        <h2>Popular Bet Types on Crypto Yolo247</h2>
                        <p>The following are the popular bet types on crypto Yolo247:</p>
                        <ol>
                            <li>Parlay Bet</li>
                            <li>Straight Bet</li>
                            <li>Future Bet</li>
                            <li>Over/Under Bet</li>
                            <li>Spread Bet</li>
                            <li>Pop Bet</li>
                            <li>Multi Bet</li>
                        </ol>

                        <h2>Bet Anywhere in the World With the Crypto Yolo247 App</h2>
                        <p>To enjoy the best of sports betting and crypto casino, you will need to get on the best crypto betting app, Yolo247. You need to follow some quick and simple steps to download the top crypto casino and sports betting app:</p>
                        <ol>
                            <li>Scan the QR code that is present on the homepage.</li>
                            <li>Download the Yolo247 crypto app and follow the simple instructions to install it.</li>
                        </ol>
                        <p>Once you have successfully installed the Yolo247 crypto app, get yourself registered. Enter your login credentials and deposit some crypto to get started with your favorite sports betting options and casino games.</p>

                        <h2>Exclusive Offers and Bonuses with Crypto Yolo247</h2>
                        <p>If you want exciting bonuses and incredible promotions, then you need to be on the most trusted online crypto gaming platform, Yolo247.</p>

                        <h2>Yolo247 Crypto Bonus</h2>
                        <p>The following are some of the amazing crypto bonuses that are present on our platform:</p>

                        <h3>Welcome Bonus</h3>
                        <p>You are too precious, and we understand that you deserve special treatment. On our platform, every new user gets a huge 100% crypto welcome bonus on their first deposit.</p>

                        <h3>Refill Bonus</h3>
                        <p>We like it when you enjoy various casino games and sports betting options on our platform. To keep the fun going for you, we offer a 3% crypto refill bonus on every deposit except the first one.</p>

                        <h2>Yolo247 Crypto Loyalty Benefits</h2>
                        <p>We value our loyal players and have an excellent loyalty program in place for them. There are 5 tiers to our crypto loyalty program: Blue, Silver, Gold, Platinum, and Elite. Players get benefits according to the tier to which they belong.</p>
                        <p>The following are different tiers of the crypto Yolo247 loyalty program:</p>

                        <h3>Blue</h3>
                        <ul>
                            <li>No turnover conditions are present. The crypto bonus is directly deposited in your safe vault, and there is no maximum limit.</li>
                        </ul>

                        <h3>Sliver</h3>
                        <ul>
                            <li>1% bonus on your every crypto redeposit.</li>
                            <li>1% crypto cashback bonus on your weekly losses.</li>
                            <li>In the Silver tier, the turnover amount required per month is 30,000 USDT.</li>
                            <li>No turnover conditions are present. The bonus is directly deposited in your safe vault, and there is no maximum limit.</li>
                        </ul>

                        <h3>Gold</h3>
                        <ul>
                            <li>2% crypto bonus on your every redeposit.</li>
                            <li>2% crypto cashback bonus on your weekly losses.</li>
                            <li>In the Gold tier, the turnover amount required per month 60,000 USDT</li>
                            <li>No turnover conditions are present. The bonus is directly deposited in your safe vault, and there is no maximum limit.</li>
                        </ul>

                        <h3>Platinum</h3>
                        <ul>
                            <li>3% crypto bonus on your every redeposit.</li>
                            <li>3% crypto cashback bonus on your weekly losses.</li>
                            <li>In the Gold tier, the turnover amount required per month is 120,000 USDT</li>
                            <li>No turnover conditions are present. The bonus is directly deposited in your safe vault, and there is no maximum limit.</li>
                        </ul>

                        <h3>Elite</h3>
                        <ul>
                            <li>Elite user's terms and conditions will be discussed by their respective relationship managers.</li>
                            <li>You can get into the Elite tier by invitation only.</li>
                        </ul>

                        <h2>FAQs on  Yolo247 Crypto Gaming and Sports Betting</h2>

                        <h3>How do you gamble with crypto?</h3>
                        <p>To gamble with crypto, all you need to do is register on Yolo247. Make a crypto deposit on the platform, and then select a casino game to play or a match to bet on. </p>

                        <h3>Which are some of the most popular online crypto casino games on Yolo247?</h3>
                        <p>Aviator, Aviatrix, Crazy Time, Roulette, and Baccarat are some of the most popular online crypto casino games on Yolo247.</p>

                        <h3>Which crypto bets are available for betting on Yolo247?</h3>
                        <p>Different crypto bets like parlay, over/under, spread, and more are available for betting on Yolo247.</p>

                        <h3>What is the popular crypto gambling site?</h3>
                        <p>Yolo247, with multiple exciting and rewarding crypto casino games and sports betting options, is the most popular crypto gambling site. This global crypto betting site offers the most secure and fastest gambling experience.</p>
                    </div>
                </Accordion>
            </AccordionWrapper>
        </>
    )
}

export default withTheme(withAppContext(SeoContentHomePage61))

//Styled Components
export const Accordion = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: ${theme('palette.seoContenAccordionHeadTextColor')};
    background: ${theme('palette.seoContenAccordionHeadBg')};

    .accordion__label, .accordion__content {
        padding: 14px 20px;
    }

    h1 {
        display: block;
        font-size: 1em;
        font-weight: bold;
        margin: 0;
    }

    h2 {
        display: block;
        font-size: 1.5em;
        font-weight: bold;
    }

    h3 {
        display: block;
        font-size: 1.1em;
        font-weight: bold;
    }

    .number {
        list-style: number;

        li {
            font-weight: bold;
        }
    }

    ul {
        li {
            font-size: 0.91em;
        }
    }

    p {
        margin: 5px 0 10px 0;
        color: ${theme('palette.seoContenAccordionInnerTextColor')};
        font-size: 0.91em;
        font-weight: normal;
        text-transform: none;
    }

    ol, ul {
        li {
            text-transform: none;
            font-size: 0.91em;
        }
    }

    a {
        /* color: #f4a322; #0366FD */
        color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
    }

    .linkBg {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
        gap: 5px;

        a {
            background: #1e1e1e;
            border-radius: 5px;
            padding: 5px 10px;
        }
    }

    .textTransformNone {
        text-transform: none;
    }

    .accordion__label{
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${theme('palette.seoContenAccordionHeadTextColor')};
        padding: 20px;
        background: ${theme('palette.seoContenAccordionHeadBg')};
        text-align: center;
        position: relative;
        cursor: pointer;

        :after {
            content: "";
            display: inline-block;
            border-style: solid;
            border-color: ${theme('palette.seoContenAccordionArrowBorder')};
            border-width: 0 2px 2px 0;
            padding: 2.5px;
            vertical-align: middle;
            transition: transform 0.3s;
            transform: ${theme('palette.seoContenAccordionArrowMarkAfter')};
            position: absolute;
            right: 20px;
        }
    }

    .accordion__label:hover{
        background: ${theme('palette.seoContenAccordionHeadHoverBg')};
    }

    .accordion__content {
        background: ${theme('palette.seoContenAccordionContentBg')};
        line-height: 1.6;
        font-size: 0.85em;
        opacity: ${theme('palette.seoContenAccordionContentOpacityOpen')};
        text-transform: capitalize;
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightOpen')};
        padding: ${theme('palette.seoContenAccordionContentPaddingOpen')};
        margin: ${theme('palette.seoContenAccordionContentMarginOpen')};
        overflow-x: ${theme('palette.seoContenAccordionContentOverFlowXOpen')};
        overflow-y: ${theme('palette.seoContenAccordionContentOverFlowYOpen')};
        transition: 0.3s;

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #f5f5f5;
            border-radius: 10px;
        }

        &::-webkit-scrollbar {
          width: 10px;
          background-color: #f5f5f5;
        }
    
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background:gray;
          margin-bottom: 10px;
        }
    }

    .accordion__input {
        display: none;
    }

    .accordion__input:checked ~ .accordion__content {
        opacity: ${theme('palette.seoContenAccordionContentOpacityClosed')};
        max-height: ${theme('palette.seoContenAccordionContentMaxHeightClosed')};
        padding: ${theme('palette.seoContenAccordionContentPaddingClosed')};
        margin: ${theme('palette.seoContenAccordionContentMarginClosed')};
    }

    .accordion__input:checked ~ .accordion__label:after {
        transform: ${theme('palette.seoContenAccordionArrowMarkBefore')};
    }

    .td,th{
        border: 1px solid white;
    }
  
    .table, th, td {
  border: 1px solid white;
  border-collapse: collapse;
}

`;

export const AccordionWrapper = styled.div`
  table,th,td{
    border: 1px solid white;
  }
`;